import { render, staticRenderFns } from "./BoField.vue?vue&type=template&id=352ea3d1&"
import script from "./BoField.vue?vue&type=script&lang=js&"
export * from "./BoField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BoField.vue"
export default component.exports